import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useIsRapydAvailable, useRedirectToDefaultCurrency, useNavigate } from '@utils/hooks';

import { userActions, useStore, walletActions } from '@modules';
import { IbanStatusesEnum, VerificationStatusesEnum } from '@modules/user/types';

import ModalLayoutOld from '@layouts/ModalLayoutOld';

import style from './WalletTopupLayoutOld.scss';

const cn = bemCssModules(style, 'WalletTopupLayoutOld');

const { created } = IbanStatusesEnum;

export const WalletTopupLayoutOld: CustomFC = props => {
  const { className, children } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ user, wallet, accounts }, dispatch] = useStore();
  const currentCurrency = useRedirectToDefaultCurrency();
  const customPath = (path: string) => `${path}/${currentCurrency}`;
  const isRapydAvailable = useIsRapydAvailable();
  const { rapyd } = wallet;
  const { data } = user;
  const isIbanCreated = data?.iban_status === created;
  const ibanAccountNumber = accounts.details[0]?.iban || '';

  const isKYCComplete = user.data?.checks.document === VerificationStatusesEnum.complete;

  useEffect(() => {
    if (isRapydAvailable) dispatch(walletActions.getRapydPaymentMethods());
    dispatch(userActions.getUserData());
  }, [isRapydAvailable]);

  const tabs = [
    { label: t('menu.topup'), link: customPath(CONST.nav.topup) },
    {
      label: `EUR ${ibanAccountNumber.slice(-4)} `,
      link: customPath(CONST.nav.walletsBuyAccountsExchange),
      hidden: !isIbanCreated,
    },
    {
      label: t('iban.top_menu.bank_account'),
      link: customPath(CONST.nav.walletsBuyAccountsInvoice),
      badge: 'SEPA',
      hidden: !isIbanCreated,
    },
    { label: t('menu.deposit'), link: customPath(CONST.nav.deposit), hidden: !isKYCComplete },
    ...rapyd.methods.map(({ id, label }) => ({
      label,
      link: customPath(`${CONST.nav.paymentMethod}/${id}`),
    })),
  ];

  const onClose = () => navigate(customPath(CONST.nav.wallets));

  return (
    <ModalLayoutOld className={cn(null, [className])} tabs={tabs} closeButton={onClose}>
      {children}
    </ModalLayoutOld>
  );
};

export default WalletTopupLayoutOld;
